import { render, staticRenderFns } from "./KBtn.vue?vue&type=template&id=e01356d8&scoped=true"
import script from "./KBtn.vue?vue&type=script&lang=ts"
export * from "./KBtn.vue?vue&type=script&lang=ts"
import style0 from "./KBtn.vue?vue&type=style&index=0&id=e01356d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01356d8",
  null
  
)

export default component.exports